// extracted by mini-css-extract-plugin
module.exports = {"container":"GeoJSONEditor_container__20LJ9","errors":"GeoJSONEditor_errors__1oa5l"};